import request from '@/api'

// 个人经验-信息获取
export async function getLevelInfomation(data) {
  return request({
    url: `/capi/web-service/experience/selectLevelAndHistory`,
    method: 'post',
    data
  })
}
// 个人账户-信息更新
export async function updateInfomation(data) {
  return request({
    url: `/capi/c-access-layer/account/update`,
    method: 'post',
    data
  })
}
// 设置密码
export async function resetSetPassword(data) {
  return request({
    url: `/capi/iam-account/v1/account/reset/set_password`,
    method: 'post',
    data
  })
}
// 登录日志
export async function getLoginLogs(data) {
  return request({
    url: `/capi/iam-account/v1/account/user/getLoginLogs`,
    method: 'post',
    data
  })
}

// 是否有密码
export async function isHavePasswordFunction(data) {
  return request({
    url: `/capi/iam-account/v1/account/user/isHavePassword`,
    method: 'post',
    data
  })
}

// 修改登录用的手机号
export async function userChangePhone(data) {
  return request({
    url: `/capi/iam-account/v1/account/user/change_phone`,
    method: 'post',
    data
  })
}

// 修改登录用的邮箱
export async function userChangeEmail(data) {
  return request({
    url: `/capi/iam-account/v1/account/user/change_email`,
    method: 'post',
    data
  })
}
// 签到-信息获取
export async function getSignInfo() {
  return request({
    url: `/capi/web-service/uaes/commons/getSignInfo`,
    method: 'post'
  })
}
// 签到-签到
export async function setSignin() {
  return request({
    url: `/capi/web-service/uaes/commons/signin`,
    method: 'post'
  })
}
